<template>
    <comp-9-prep-adherence :section="9" :page="37" :nextDisabled="nextDisabled">
        <p>
            Earlier you put a checkmark next to some reasons why you’re on PrEP. Reminding yourself of those reasons is a very important to making any type of
            change, especially changing how often you take a medication. Take a look at the list again and place a check mark next to each item that might
            motivate you to take your PrEP every day or add some of your own reasons below.
        </p>
        <v-checkbox
            v-for="motivation in prepMotivations"
            :key="motivation.id"
            :label="motivation.text"
            :value="motivation.id"
            v-model="selectedMotivations"
            hide-details
            dense
        ></v-checkbox>
        <v-text-field v-if="showManualResponse" outline single-line type="text" v-model.trim="selectedMotivationResponse"></v-text-field>
    </comp-9-prep-adherence>
</template>

<script>
import { sync } from 'vuex-pathify';
import { filter, map, forEach } from 'lodash';

export default {
    data: function() {
        return {
            selectedMotivations: [],
            selectedMotivationResponse: null
        };
    },
    computed: {
        prepSelectedMotivations() {
            let prepSelectedMotivations = map(filter(this.prepMotivations, 'selected'), 'id');

            if (prepSelectedMotivations) {
                return prepSelectedMotivations;
            } else return [];
        },
        prepSelectedMotivationsResponse() {
            let userEnteredMotivation = filter(filter(this.prepMotivations, 'selected'), 'userEntered');

            if (userEnteredMotivation.length > 0) {
                return userEnteredMotivation[0].response;
            }

            return null;
        },
        showManualResponse() {
            if (filter(filter(this.prepMotivations, 'selected'), 'userEntered').length > 0) {
                return true;
            }

            return false;
        },
        prepMotivations: sync('section9/prepMotivatorsRevisited')
    },
    methods: {
        nextDisabled() {
            if (this.selectedMotivations.length === 0 || (this.showManualResponse && !this.selectedMotivationResponse)) {
                return true;
            } else {
                return false;
            }
        }
    },
    watch: {
        selectedMotivations() {
            forEach(this.prepMotivations, o => {
                if (this.selectedMotivations.includes(o.id)) {
                    o.selected = true;

                    if (o.userEntered) {
                        o.response = this.selectedMotivationResponse;
                    }
                } else {
                    o.selected = false;

                    if (o.userEntered) {
                        o.response = null;
                    }
                }
            });
        },
        selectedMotivationResponse() {
            forEach(this.prepMotivations, o => {
                if (o.userEntered && o.selected) {
                    o.response = this.selectedMotivationResponse;
                }
            });
        }
    },
    mounted() {
        this.selectedMotivations = this.prepSelectedMotivations;
        this.selectedMotivationResponse = this.prepSelectedMotivationsResponse;

        // if this is the first time visiting the screen, no items will be selected.
        // if that is the case, copy the motivations from the earlier version of this activity
        if (this.prepSelectedMotivations.length === 0) {
            let priorMotivations = this.$store.get('section9/prepMotivators');

            forEach(priorMotivations, o => {
                if (o.selected) {
                    this.selectedMotivations.push(o.id);

                    if (o.userEntered) {
                        this.selectedMotivationResponse = o.response;
                    }
                }
            });
        }
    }
};
</script>
